import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LayoutColumns, ViewType } from '../types/IHealthCheck';
import {
  loadLandingView,
  loadLayoutColumns,
  saveLandingView,
  saveLayoutColumns,
} from './lsHelpers';

interface StatusState {
  error: string | null;
  /** Health Check view opened when no specific one is requested. */
  landingView: ViewType;
  layoutColumns: 2 | 3;
}

const initialState: StatusState = {
  error: null,
  landingView: loadLandingView(),
  layoutColumns: loadLayoutColumns(),
};

const statusItemsSlice = createSlice({
  name: 'statusItems',
  initialState,
  reducers: {
    setError(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    setLandingView: (state, action: PayloadAction<ViewType>) => {
      state.landingView = action.payload;
      saveLandingView(action.payload);
    },
    setLayoutColumns: (state, action: PayloadAction<LayoutColumns>) => {
      state.layoutColumns = action.payload;
      saveLayoutColumns(action.payload);
    },
  },
});

export const {
  setError,

  setLandingView,
  setLayoutColumns,
  // setRTPStatusItems,
} = statusItemsSlice.actions;

export default statusItemsSlice.reducer;
